import { isIOSMobile } from "@/utils/isIOSMobile"
import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/")({
  beforeLoad: () => {
    if (isIOSMobile()) {
      window.location.href = "https://testflight.apple.com/join/dgV43kv5"

      return
    }

    throw redirect({ to: "/home/voortgang" })
  },
})
